import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import clsx from 'clsx';

import { IconButton, Tooltip, Typography, styled, Popover } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';

import {dataRemoveFilter} from "../../redux/data/dataActions";


const PREFIX = 'ClearFilterBtn';

const classes = {
    root: `${PREFIX}-root`,
    popover: `${PREFIX}-popover`,
    paper: `${PREFIX}-paper`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
		top: '16px',
		zIndex: '500'
	},

    // listeners: {
    // 	position: 'relative',
    // 	top: '28px',
    // 	right: '8px',
    // 	color: theme.palette.grey[500],
    // 	zIndex: '500'
    // },
    [`& .${classes.popover}`]: {
		pointerEvents: 'none',
	},

    [`& .${classes.paper}`]: {
		padding: theme.spacing(1),
	}
}));

export default function ClearFilterBtn(id, invalid) {
	const dispatch = useDispatch();


	// App State
	const filters = useSelector(state => state.data.filters);

	// Component State
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const filter = filters.find(f => {
			return f.id.toLowerCase() === id.toLowerCase()
		});

		if (filter) {
			setVisible(true);
		} else {
			setVisible(false);
		}
	}, [filters]);

	const clearFilter = () => {
		dispatch(dataRemoveFilter(id));
	};

	const iconStyle = {};
	if (invalid) {
		iconStyle.color = 'red';
	}

	if (visible) {
		return (
            <Root>
				<Tooltip title="Clear Filter" arrow placement="left" className={classes.root}>
					<IconButton
                        aria-label="delete"
                        onClick={ () => {clearFilter()}}
                        style={iconStyle}
                        size="large">
						<span className={clsx('fa-stack')} style={{verticalAlign: 'top', height: '24px', width: '24px'}}>
						  <i className={clsx('fas fa-minus-circle fa-stack-2x')} style={{fontSize: '10px', paddingTop: '15px', paddingLeft: '10px'}}></i>
						  <i className={clsx('fas fa-filter fa-stack-1x')} style={{ fontSize: '18px', lineHeight: '28px', paddingRight: '5px'}}></i>
						</span>
					</IconButton>
				</Tooltip>
			</Root>
        );
	} else {
		return null;
	}
}
